<script setup lang="ts">
/**
 * FAQ for the pricing page in the template's two-column accordion. Questions
 * come from the homepage FAQ (prices interpolated from the plan list) plus
 * the two pack questions under premium.faq; the "30 days end" question exists
 * in both blocks so it is only taken once.
 */
const { t } = useI18n()
const { jobPackPrice, exportCreditPrice } = usePremiumPlans()

const items = computed(() => [
  { id: 'pack', question: t('premium.faq.q1'), answer: t('premium.faq.a1') },
  ...(['free', 'account', 'facts', 'ats', 'after30', 'linkedin'] as const).map(id => ({
    id,
    question: t(`homepage.faq.${id}.q`),
    answer: t(`homepage.faq.${id}.a`, { pack: jobPackPrice, single: exportCreditPrice }),
  })),
  { id: 'benefits', question: t('premium.faq.q3'), answer: t('premium.faq.a3') },
])
</script>

<template>
  <section id="faq" class="sofax surface-alt">
    <div class="section-space">
      <div class="shell">
        <div class="mx-auto mb-10 max-w-2xl text-center md:mb-[3.75rem] lg:mb-20">
          <h2>{{ t('premium.faq.title') }}</h2>
        </div>

        <SofaxAccordion :items="items" :columns="2" :default-open="0" name="pricing-faq" />
      </div>
    </div>
  </section>
</template>
